exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".detail-row td[data-v-aec8a6e4]{height:55px}", "", {"version":3,"sources":["/app/src/components/master/sellingTariff/Surcharge.vue"],"names":[],"mappings":"AACA,gCACE,WAAa,CACd","file":"Surcharge.vue","sourcesContent":["\n.detail-row td[data-v-aec8a6e4] {\n  height: 55px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-aec8a6e4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/master/sellingTariff/Surcharge.vue
// module id = 1016
// module chunks = 10